module.exports = __webpack_public_path__ + "media/src/images/step2-0487330323211565d95bb97360f8f4fb.png";